import axios from "axios";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;
const BASE_URL = `${SERVER_URL}/event`;

async function getRegistrationDetails(token, eventCode) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${BASE_URL}/registration?eventCode=${eventCode}`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function getNumRegisteredParticipants(token, eventCode) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.get(`${BASE_URL}/registration/count?eventCode=${eventCode}`);

    return data;
  } catch (error) {
    console.log('error -> ', error);
    throw error;
  }
}

async function submitRegistrationData(token, registrationData) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${BASE_URL}/register`, registrationData);
    return data;
  } catch (e) {
    throw e;
  }
}

const generalEventRegistrationService = {
  getRegistrationDetails,
  submitRegistrationData,
  getNumRegisteredParticipants,
};

export default generalEventRegistrationService;
